var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wmzdlephka",
    x1: 0.925,
    y1: 0.956,
    x2: 0.051,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18439",
    transform: "translate(-1133.5 -6957)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 95",
    width: 36,
    height: 36,
    rx: 7,
    transform: "translate(1133.5 6957)",
    style: {
      fill: "url(#wmzdlephka)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.357 18V9.79h2.755l.413-3.2h-3.168V4.546c0-.926.256-1.558 1.586-1.558h1.693V.125A22.961 22.961 0 0 0 44.169 0a3.856 3.856 0 0 0-4.116 4.229v2.36H37.29v3.2h2.763V18z",
    style: {
      fill: "#fff"
    },
    transform: "translate(1109.537 6966)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.66cda7a74e3ad2f942be08cb8f4f1c41.svg";
export { ForwardRef as ReactComponent };